var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { SkeletonRegistry } from './skeleton/SkeletonRegistry';
import { ActionRegistry } from './action/ActionRegistry';
import { ActorFilterRegistry } from './actorfilter/ActorFilterRegistry';
import { AspectFilterRegistry } from './aspectfilter/AspectFilterRegistry';
import { ConditionRegistry } from './condition/ConditionRegistry';
import { TraitRegistry } from './trait/TraitRegistry';
import { runtime } from '../classes/runtime/Runtime';
import { memoize } from '../utils/mobx/decorators/memoize';
import { EventRegistry } from './event/EventRegistry';
import { ValueRegistry } from './value/ValueRegistry';
export class Registry {
    runtime;
    constructor(runtime) {
        this.runtime = runtime;
        if (this.runtime.isBrowserRuntime) {
            window.registry = this;
        }
    }
    skeletonRegistry = new SkeletonRegistry(this);
    actionRegistry = new ActionRegistry(this);
    actorFilterRegistry = new ActorFilterRegistry(this);
    aspectFilterRegistry = new AspectFilterRegistry(this);
    conditionRegistry = new ConditionRegistry(this);
    eventRegistry = new EventRegistry(this);
    traitRegistry = new TraitRegistry(this);
    valueRegistry = new ValueRegistry(this);
    get slotRegistry() {
        return runtime.solidPackages.Edit.slotRegistry;
    }
}
__decorate([
    memoize
], Registry.prototype, "slotRegistry", null);
// console.time('Registry');
const registry = new Registry(runtime);
// console.timeEnd('Registry');
const skeletonRegistry = registry.skeletonRegistry;
const actionRegistry = registry.actionRegistry;
const actorFilterRegistry = registry.actorFilterRegistry;
const aspectFilterRegistry = registry.aspectFilterRegistry;
const conditionRegistry = registry.conditionRegistry;
const traitRegistry = registry.traitRegistry;
const eventRegistry = registry.eventRegistry;
const valueRegistry = registry.valueRegistry;
const slotRegistry = () => registry.slotRegistry;
runtime.registry = registry;
export { registry, skeletonRegistry, actionRegistry, actorFilterRegistry, aspectFilterRegistry, conditionRegistry, traitRegistry, eventRegistry, valueRegistry, slotRegistry };
